import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M106.5 65.42c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#ACB8C3"
      d="M81.31 23.52a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.57 54.65a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      d="m15.7 83.77 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM108.57 21.58H103v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H100v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M33.55 89.9h57.44a4.79 4.79 0 0 0 4.79-4.79V34.85a4.79 4.79 0 0 0-4.79-4.79H43.12"
    />
    <path
      fill="#7B8493"
      d="M58 67.9c-1.24 0-2.25-1.01-2.25-2.25v-1.13c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v1.13c0 1.24-1.01 2.25-2.25 2.25M69.46 78.16h-1.15c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h1.15c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#ACB8C3"
      d="M23.98 80.33V27.67c0-5.29 4.29-9.57 9.57-9.57s9.57 4.29 9.57 9.57v52.66"
    />
    <path
      fill="#7B8493"
      d="M33.55 89.9c5.29 0 9.57-4.29 9.57-9.57s-4.29-9.57-9.57-9.57-9.57 4.29-9.57 9.57 4.29 9.57 9.57 9.57M78.66 59.56c3.81 0 6.9 2.97 6.9 6.63 0 2.83-4.12 8.21-6 10.51-.22.27-.55.42-.91.42s-.69-.16-.91-.42c-1.87-2.3-6-7.68-6-10.51 0-3.66 3.09-6.63 6.9-6.63z"
    />
    <path
      fill="#C7D0D9"
      d="M78.66 68.63a2.65 2.65 0 1 0 0-5.3 2.65 2.65 0 0 0 0 5.3"
    />
    <path
      fill="#7B8493"
      d="M57.95 41.18c3.81 0 6.9 2.97 6.9 6.63 0 2.83-4.12 8.21-6 10.51-.22.27-.55.42-.91.42s-.69-.16-.91-.42c-1.87-2.3-6-7.68-6-10.51 0-3.66 3.09-6.63 6.9-6.63z"
    />
    <path
      fill="#C7D0D9"
      d="M57.95 49.95a2.65 2.65 0 1 0 0-5.3 2.65 2.65 0 0 0 0 5.3"
    />
    <path
      fill="#7B8493"
      d="M61.71 78.16H59.2c-1.9 0-3.45-1.55-3.45-3.45V72.2c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v1.47h1.47c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25z"
    />
  </svg>
);
const SvgEnrichedIconRoadmapGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconRoadmapGreyscale);
export default Memo;
